import React, { useState } from 'react';
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const nav = [
  { to: '/admin', label: 'Dashboard', icon: '📊', end: true },
  { to: '/admin/students', label: 'Students', icon: '👥' },
  { to: '/admin/questions', label: 'Questions', icon: '❓' },
  { to: '/admin/chapters', label: 'Chapters & Notes', icon: '✅' },
  { to: '/admin/taught-log', label: 'Taught Log', icon: '🗓️' },
  { to: '/admin/videos', label: 'Videos', icon: '🎬' },
  { to: '/admin/cards', label: 'Flashcards', icon: '🃏' },
  { to: '/admin/manual-reviews', label: 'Manual Reviews', icon: '🚩' },
  { to: '/admin/question-lookup', label: 'Question Lookup', icon: '🔎' },
  // Version 2 group (BRIEFS C3.4). "Notes (by chapter)" covers all the notes tabs (C4.4–C8.1,
  // renamed in C11.7; the older notes pages are under "Advanced" on those tabs).
  { group: 'Version 2' },
  { to: '/admin/v2/chapters', label: 'Notes (by chapter)', icon: '📘',
    match: (p) => p.startsWith('/admin/v2') && !V2_STUDENT_PAGES.some((s) => p.startsWith(s)) },
  { to: '/admin/v2/activity', label: 'Activity', icon: '📈' },
  { to: '/admin/v2/reports', label: 'Daily reports', icon: '📧' },
  { to: '/admin/v2/devices', label: 'Devices', icon: '💻' },
  { to: '/admin/v2/settings', label: 'Study settings', icon: '⚙️' },
  // C11.3: printable page (outside this layout, like the test review).
  { to: '/admin/v2/print', label: 'Print questions', icon: '🖨️' },
];
const V2_STUDENT_PAGES = ['/admin/v2/activity', '/admin/v2/reports', '/admin/v2/devices', '/admin/v2/settings'];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <aside style={{
        width: 240, background: 'var(--sidebar-bg)', color: 'var(--sidebar-text)',
        display: 'flex', flexDirection: 'column', flexShrink: 0,
        position: 'fixed', top: 0, left: 0, height: '100vh', zIndex: 100,
        transform: open ? 'translateX(0)' : undefined,
      }} className="sidebar">
        <div style={{ padding: '24px 20px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 24 }}>🎯</span>
            <div>
              <div style={{ color: 'white', fontFamily: 'Sora', fontWeight: 700, fontSize: 15 }}>Dream NEET</div>
              <div style={{ fontSize: 11, opacity: 0.5 }}>Admin Panel</div>
            </div>
          </div>
        </div>
        <nav style={{ flex: 1, padding: '12px 10px', overflowY: 'auto' }}>
          {nav.map(n => n.group ? (
            <div key={n.group} style={{
              padding: '14px 12px 6px', fontSize: 11, textTransform: 'uppercase',
              letterSpacing: '0.06em', opacity: 0.55,
            }}>{n.group}</div>
          ) : (
            <NavLink key={n.to} to={n.to} end={n.end} style={({ isActive: navActive }) => {
              const isActive = n.match ? n.match(pathname) : navActive;
              return ({
              display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
              borderRadius: 8, marginBottom: 2, textDecoration: 'none', fontSize: 14,
              color: isActive ? 'white' : 'var(--sidebar-text)',
              background: isActive ? 'var(--sidebar-active)' : 'transparent',
              fontWeight: isActive ? 600 : 400,
            }); }}>
              <span>{n.icon}</span>{n.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: 12, opacity: 0.5, marginBottom: 8 }}>Signed in as</div>
          <div style={{ color: 'white', fontWeight: 600, fontSize: 14, marginBottom: 12 }}>{user?.full_name || 'Admin'}</div>
          <button onClick={handleLogout} className="btn btn-ghost"
            style={{ width: '100%', justifyContent: 'center', color: 'var(--sidebar-text)', borderColor: 'rgba(255,255,255,0.15)' }}>
            Sign Out
          </button>
        </div>
      </aside>
      {/* Main */}
      <main style={{ marginLeft: 240, flex: 1, padding: '32px', minHeight: '100vh' }}>
        <Outlet />
      </main>
      <style>{`
        @media (max-width: 768px) {
          aside.sidebar { transform: translateX(-100%); }
          main { margin-left: 0 !important; padding: 16px !important; }
        }
      `}</style>
    </div>
  );
}
